











import { TypeDisplay } from '@bambeehr/pollen';
import { defineComponent, PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CTABladeHeadline',
  components: {
    TypeDisplay,
  },
  props: {
    headline: {
      type: String as PropType<string>,
      required: false,
      default: 'Want to learn more about Bambee?',
    },
    variant: {
      type: String as PropType<string>,
      required: false,
    },
  },
});
